import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import useCommonStyles from './useCommonStyles';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.typography.h2,
  },
}));

const H2 = ({ children, center, right, white, secondary, oneLine, className, ...props }) => {
  const classes = useStyles();
  const common = useCommonStyles();

  return (
    <Typography
      variant="h2"
      classes={{ root: classes.root }}
      className={clsx({
        [common.center]: center,
        [common.right]: right,
        [common.white]: white || secondary,
        [common.wrapEllipsis]: oneLine,
        [className]: className.length > 0,
      })}
      {...props}
    >
      {children}
    </Typography>
  );
};

H2.defaultProps = {
  center: false,
  right: false,
  white: false,
  secondary: false,
  oneLine: false,
  className: '',
};

H2.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]).isRequired,
  center: PropTypes.bool,
  right: PropTypes.bool,
  white: PropTypes.bool,
  secondary: PropTypes.bool,
  oneLine: PropTypes.bool,
  className: PropTypes.string,
};

export default H2;
